import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import { DataService } from 'app/services/data.service';
import { map, takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DrakeBotComponent } from "../drake-bot/drake-bot.component";
import { environment } from 'environments/environment';
import { TranslocoPipe } from '@ngneat/transloco';

interface Help {
  title: string | null;
  content: string | null;
}

@Component({
  selector: 'app-help-toolbar',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, DrakeBotComponent, TranslocoPipe],
  templateUrl: './help-toolbar.component.html',
  styleUrls: ['./help-toolbar.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [TranslocoPipe]
})
export class HelpToolbarComponent implements OnInit, OnDestroy {

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  public drakeChatBot: boolean = environment.modules.chatBot;

  data: Help;
  opened = false;
  currentUrl: string = '';
  showChatBot: boolean = false;

  constructor(private router: Router, private dataService: DataService, private translocoPipe: TranslocoPipe) { }

  ngOnInit(): void {
    // Ascolta gli eventi di navigazione e chiudi la sidebar quando la rotta cambia
    this.router.events.pipe(
      takeUntil(this._unsubscribeAll)
    ).subscribe(event => {
      if (event instanceof NavigationStart) {
        this.close();
      }
    });

    var helpEnabled:boolean = environment.modules?.help;//environment.modules && environment.modules != null && environment.modules != undefined && environment.modules?.help != undefined;
    if (helpEnabled) {
      this.getData().pipe(
        takeUntil(this._unsubscribeAll)
      ).subscribe(
        (data) => {
          this.data = data;
          console.log('data', data);
        },
        (error) => {
          console.error('Errore nella richiesta:', error);
        }
      );
    }
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    close();
  }

  toggleSidenav() {
    this.opened = !this.opened;
    this.currentUrl = this.router.url.slice(3);
    this.getData().subscribe(
      (data) => {
        this.data = data;
        //console.log('data', data);
      },
      (error) => {
        console.error('Errore nella richiesta:', error);
      }
    );
  }

  close(): void {
    this.opened = false;
  }
  closeChatBot(): void {
    this.showChatBot = false;
  }
  openChatBot() {
    this.close();
    //console.log('apri chatbot', this.showChatBot);
    this.showChatBot = true;
    //console.log('dopo chatbot', this.showChatBot);
  }

  getData() {
    return this.dataService.getScopeData('HELP', 'HELP.DEFAULT').pipe(
      map((response: any) => {
        if (response && Array.isArray(response.data)) {
          const filteredData = response.data.filter(item => item.UrlPagina === this.currentUrl);
          if (filteredData.length > 0) {
            const item = filteredData[0];
            return {
              title: item.Title ? item.Title : '',
              content: item.Description ? item.Description : ''
            } as Help;
          } else {
            return {
              title: this.translocoPipe.transform('help.noHelp'),
              content: this.translocoPipe.transform('help.noHelpDesc')
            } as Help;
          }
        } else {
          //console.error('Errore: risposta non contiene un array nella proprietà "data"', response);
          return {
            title: this.translocoPipe.transform('help.getHelpError'),
            content: this.translocoPipe.transform('help.getHelpErrorDesc')
          };
        }
      })
    );
  }

}
